module.exports = __webpack_public_path__ + "img/1540647495.a13b8776.jpg";